export default function Section({children}){
    
    return(
        <div id="section" className="section">
            {children}
        </div>
    )

}